function genSlug(s) {
  return `/${s.toLowerCase().replace(/\s+/g, "-")}/`
}

function extractServiceName(ServiceName) {
  return ServiceName.substring(0, ServiceName.toLowerCase().indexOf(" service"))
}

module.exports = { genSlug, extractServiceName }
